import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import auth from "./slices/auth";
import company from "./slices/company";
import ui from "./slices/ui";
import workspace from "./slices/workspace";
import branch from "./slices/branch";
import permission from "./slices/permission";
import role from "./slices/role";
import user from "./slices/user";
import dashboard from "./slices/dashboard";
import notification from "./slices/notification";
import auditLog from "./slices/auditLog";
import account from "./slices/account";
import brand from "./slices/brand";
import category from "./slices/category";
import packageUnit from "./slices/packageUnit";
import paymentMethod from "./slices/paymentMethod";
import quantityUnit from "./slices/quantityUnit";
import taxCode from "./slices/taxCode";
import expenseCategory from "./slices/expenseCategory";
import currency from "./slices/currency";
import item from "./slices/item";
import stockLevel from "./slices/stockLevel";
import inventoryLog from "./slices/inventoryLog";
import shift from "./slices/shift";
import customer from "./slices/customer";
import supplier from "./slices/supplier";
import receipt from "./slices/receipt";
import sale from "./slices/sale";
import purchaseOrder from "./slices/purchaseOrder";
import invoice from "./slices/invoice";
import creditNote from "./slices/creditNote";
import quotation from "./slices/quotation";
import debt from "./slices/debt";
import expense from "./slices/expense";
import announcement from "./slices/announcement";
import smsOutbox from "./slices/smsOutbox";
import smsTemplate from "./slices/smsTemplate";
import ledgerEntry from "./slices/ledgerEntry";
import payment from "./slices/payment";
import sequence from "./slices/sequence";
import documentHeader from "./slices/documentHeader";
import companyCharge from "./slices/companyCharge";
import bi from "./slices/bi";
import settings from "./slices/settings";
import unallocatedPayment from "./slices/unallocatedPayment";
import whatsapp from "./slices/whatsapp";

const rootReducer = combineReducers({
  auth,
  company,
  ui,
  workspace,
  branch,
  permission,
  role,
  user,
  dashboard,
  notification,
  auditLog,
  account,
  brand,
  category,
  packageUnit,
  paymentMethod,
  quantityUnit,
  taxCode,
  expenseCategory,
  currency,
  item,
  stockLevel,
  inventoryLog,
  shift,
  customer,
  supplier,
  receipt,
  sale,
  purchaseOrder,
  invoice,
  creditNote,
  quotation,
  debt,
  expense,
  announcement,
  smsOutbox,
  smsTemplate,
  ledgerEntry,
  payment,
  sequence,
  documentHeader,
  companyCharge,
  bi,
  settings,
  unallocatedPayment,
  whatsapp,
});

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Strongly typed custom hooks for React components
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
